import type { ExplainLang } from '@/sanskrit/lib/sanskrit/types'

export type LearnerMode = 'kids' | 'adult'

export type IastMode = 'always' | 'auto' | 'never'

export type MotionMode = 'system' | 'reduce' | 'full'

export interface Settings {
    onboarded: boolean
    mode: LearnerMode
    lang: ExplainLang
    iast: IastMode
    knowsDevanagari: boolean
    motion: MotionMode
    textScale: number
    captions: boolean
    voiceURI: string | null
    rate: number
    dailyGoal: number
}

export const DEFAULT_SETTINGS: Settings = {
    onboarded: false,
    mode: 'adult',
    lang: 'en',
    iast: 'auto',
    knowsDevanagari: false,
    motion: 'system',
    textScale: 1,
    captions: true,
    voiceURI: null,
    rate: 0.85,
    dailyGoal: 30
}

export const SETTINGS_KEY = 'vani:settings:v1'

export const PROGRESS_KEY = 'vani:progress:v1'

export const reviveSettings = (raw: unknown): Settings => {
    if (!raw || typeof raw !== 'object') return DEFAULT_SETTINGS
    const r = raw as Partial<Settings>

    return {
        ...DEFAULT_SETTINGS,
        ...r,
        mode: r.mode === 'kids' ? 'kids' : 'adult',
        lang: r.lang === 'hi' ? 'hi' : 'en',
        iast: r.iast === 'always' || r.iast === 'never' ? r.iast : 'auto',
        motion: r.motion === 'reduce' || r.motion === 'full' ? r.motion : 'system',
        textScale: typeof r.textScale === 'number' && r.textScale >= 0.9 && r.textScale <= 1.4 ? r.textScale : 1,
        rate: typeof r.rate === 'number' && r.rate >= 0.4 && r.rate <= 1.4 ? r.rate : DEFAULT_SETTINGS.rate
    }
}
